import React from 'react';

const DefaultTypeInteger = (props) => {
  const { data, schema, path = [] } = props;
  return (
    <div className={`default-type-integer depth-${path.length}`}>
      <strong className="default-type-integer-title">{schema.title}</strong>{' '}
      <span className="default-type-integer-value">{data}</span>
    </div>
  );
};

export default DefaultTypeInteger;